export default "__VITE_ASSET__85e1927b__"